var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGrabber = function SvgGrabber(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 6.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m0 5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M9 15a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0m3.5-8.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M14 10a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0m-1.5 6.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"
  })));
};
export default SvgGrabber;